import React, { useState, useEffect, useRef, useMemo } from "react";
import classNames from "classnames";
import { useHistory } from "react-router-dom";
import moment from "moment";
import useBaseInfo from "../store/useBaseInfo";
import useBasicFormData from "../store/useBasicFormData";
import TimePicker from "../components/TimePicker";
import { MAINTANCE_TYPE_CODE } from "../config/constants";
import PickupServiceModal from "./PickupServiceModal";
import usePickupAddress from "../store/usePickupAddress";
import CollapseContent from "../components/CollapseContent";
import { sendReport } from "../../../utils/reporter";
import PickupAddress from "../pickupAddress";
import PlateInput from "../plateInput";
import "./index.scss";
import useReserveStoreInfo from "../hooks/useReserveStoreInfo";
import useReserveTimeInfo from "../hooks/useReserveTimeInfo";

export default function ContactForm(props) {
  const { reserveItems, remarkContent } = props;
  const history = useHistory();
  const { baseInfo } = useBaseInfo();
  const { basicFormData, setContactInfoData } = useBasicFormData();
  const { pickupAddress } = usePickupAddress();
  const [showModal, setShowModal] = useState(false);
  const [isPickerVisible, setisPickerVisible] = useState(false);
  const [inFocusType, setInFocusType] = useState("");

  const inputFocusingRef = useRef(false);
  const nameInputRef = useRef<HTMLInputElement | null>(null);
  const mobileInputRef = useRef<HTMLInputElement | null>(null);

  // 回显预约门店和时间信息
  const reserveStoreInfo = useReserveStoreInfo();
  const reserveTimeInfo = useReserveTimeInfo();

  const [reserveProjects, repairItemNames] = useMemo(() => {
    if (!reserveItems?.length) {
      return ["", ""];
    }
    const selectedServiceItems = reserveItems.filter(
      (serviceItem) => !!serviceItem.checked
    );
    let itemNames: string[] = [];
    let repairItemNames: string[] = [];
    selectedServiceItems.forEach((serviceItem) => {
      itemNames.push(serviceItem.name);

      // 查询维修的子项
      if (serviceItem.code === MAINTANCE_TYPE_CODE.REPAIR) {
        repairItemNames = serviceItem.children
          .filter((subOptionItem) => !!subOptionItem.checked)
          .map((subOptionItem) => {
            return subOptionItem.name;
          });
      }
    });
    return [itemNames.join(" + "), repairItemNames.join("、")];
  }, [reserveItems]);

  const pickupServiceAdLink = useMemo(() => {
    return basicFormData.contactInfoStepData.pickupRightUrl || "";
  }, [basicFormData.contactInfoStepData]);

  const arriveStoreTime = useMemo(() => {
    if (reserveTimeInfo) {
      const { timestamp, startTime } = reserveTimeInfo;
      return `${moment(timestamp).format("MM月DD日")} ${startTime}`;
    }
    return "";
  }, [reserveTimeInfo]);

  useEffect(() => {
    function onResizeHandler() {
      console.info("page resizing~~~~~~~~~~~", document.body.offsetHeight);
      if (inputFocusingRef.current) {
        // 直接移到底
        window.scrollTo({
          top: document.body.offsetHeight,
          behavior: "smooth",
        });
      }
    }
    window.addEventListener("resize", onResizeHandler);

    return () => {
      window.removeEventListener("resize", onResizeHandler);
    };
  }, []);

  useEffect(() => {
    // 取送车模块展示则上报
    if (basicFormData.contactInfoStepData.hasPickupServiceRight) {
      sendReport({
        mcode: "上门取送车入口曝光",
        point: "P11183`B023",
      });
    }
  }, [basicFormData.contactInfoStepData.hasPickupServiceRight]);

  const toggleServiceOptions = (isUse) => {
    // setUsePickupService(isUse);
    setContactInfoData({
      usePickupService: isUse,
    });

    if (isUse) {
      sendReport({
        mcode: "上门取送车选择使用点击",
        point: "P11183`B024",
      });
    } else {
      sendReport({
        mcode: "上门取送车选择不使用",
        point: "P11183`B025",
      });
    }
  };

  const hideModal = () => {
    setShowModal(false);
  };

  const onTapPickupLabel = () => {
    setShowModal(true);
  };

  // 跳转取车地点
  const handleLinkToAddress = () => {
    history.push(`${history.location.pathname}${history.location.search}#select-address`)
    sendReport({
      mcode: "取车地点输入点击",
      point: "P11183`B027",
    });
  };

  // 跳转到输入车牌页
  const handleLinkToAddPlateNumnber = () => {
    history.push(`${history.location.pathname}${history.location.search}#add-plate`)
  };

  const onTapPickupTimeItem = () => {
    // setShowTimePicker(true);
    setisPickerVisible(true);
    sendReport({
      mcode: "取车时间输入点击",
      point: "P11183`B026",
    });
  };

  const onPickerHidden = () => {
    setisPickerVisible(false);
  };

  const onTapPickupAdHandler = () => {
    window.location.href = pickupServiceAdLink;
  };

  const onContactNameChange = (e) => {
    setContactInfoData({
      contactName: e.target.value,
    });
  };

  const onContactPhoneChange = (e) => {
    const phone = e.target.value;
    // 过长不允许输入
    if (phone.length > 11) return;
    setContactInfoData({
      contactPhone: e.target.value,
    });
  };

  const onTimePickerConfirm = (value) => {
    if (value && value.length > 0) {
      setContactInfoData({
        pickupServiceTime: value.join(":"),
      });
    }
  };

  // 聚焦处理
  const onNameInputFocus = () => {
    setInFocusType("name");
    inputFocusingRef.current = true;
    sendReport({
      mcode: "联系人输入点击",
      point: "P11183`B018",
    });
  };

  // 聚焦处理
  const onMobileInputFocus = () => {
    setInFocusType("phone");
    inputFocusingRef.current = true;
    sendReport({
      mcode: "联系人输入点击",
      point: "P11183`B019",
    });
  };

  return (
    <div className="contact-form-container">
      <div className="reservation-summary-card">
        <div className="form-item">
          <div className="item-label">预约项目</div>
          <div className="item-content">{reserveProjects}</div>
        </div>
        {repairItemNames && (
          <div className="form-item">
            <div className="item-label">维修部件/问题</div>
            <div className="item-content">{repairItemNames}</div>
          </div>
        )}
        {remarkContent && (
          <div className="form-item">
            <div className="item-label">备注</div>
            <CollapseContent
              className="form-remark-content"
              contentText={remarkContent}
            />
          </div>
        )}
        <div className="form-item">
          <div className="item-label">预约门店</div>
          <div className="item-content">{reserveStoreInfo?.name}</div>
        </div>
        <div className="form-item">
          <div className="item-label">到店时间</div>
          <div className="item-content">{arriveStoreTime}</div>
        </div>
      </div>
      {basicFormData.contactInfoStepData?.hasPickupServiceRight ? (
        <div className="pickup-service-field">
          <div className="form-item">
            <div className="item-label" onClick={onTapPickupLabel}>
              上门取车服务
              <i className="info-icon" />
            </div>
            {!basicFormData.contactInfoStepData.pickupServiceTooFar ? (
              <div className="service-options">
                <div
                  className={classNames("option-item", {
                    selected:
                      basicFormData.contactInfoStepData.usePickupService,
                  })}
                  onClick={() => toggleServiceOptions(true)}
                >
                  <i className="option-icon" />
                  <span>使用</span>
                </div>
                <div
                  className={classNames("option-item", {
                    selected:
                      !basicFormData.contactInfoStepData.usePickupService,
                  })}
                  onClick={() => toggleServiceOptions(false)}
                >
                  <i className="option-icon" />
                  <span>不使用</span>
                </div>
              </div>
            ) : null}
          </div>
          {basicFormData.contactInfoStepData.pickupServiceTooFar ? (
            <div className="form-item-tips">
              上门取送车支持提前 14 天预约；超出 14 天的预约，门店将在回店前 1 天联系您安排
            </div>
          ) : (
            <div className="form-item-tips">
              你享有取送车权益，可预约专人上门取车
            </div>
          )}
        </div>
      ) : (
        <React.Fragment>
          {basicFormData.contactInfoStepData?.hasPickupServiceRight &&
          pickupServiceAdLink ? (
            <div className="pickup-car-ad" onClick={onTapPickupAdHandler}>
              <div className="text-field">
                <i className="ad-icon" />
                <span>取送车服务，专人上门，省时又省力</span>
              </div>
              <span className="action-text">查看</span>
            </div>
          ) : (
            <div className="pickup-car-ad-fill" />
          )}
        </React.Fragment>
      )}

      {basicFormData.contactInfoStepData?.hasPickupServiceRight &&
        basicFormData.contactInfoStepData.usePickupService && (
          <div className="pick-info-field">
            <div className="form-item-field">
              <span className="form-label">取车时间</span>
              <div className="content-side" onClick={onTapPickupTimeItem}>
                <span
                  className={classNames("", {
                    "has-content":
                      !!basicFormData.contactInfoStepData?.pickupServiceTime,
                  })}
                >
                  {reserveTimeInfo &&
                  basicFormData.contactInfoStepData?.pickupServiceTime
                    ? `${reserveTimeInfo.date} ${basicFormData.contactInfoStepData.pickupServiceTime}`
                    : "请选择"}
                </span>
                {/* <span>请选择</span> */}
                <i className="arrow-icon" />
              </div>
            </div>
            <div className="form-item-field align-top">
              <span className="form-label">取车地点</span>
              <div className="content-side " onClick={handleLinkToAddress}>
                <span
                  className={classNames("content-text", {
                    "has-content": !!pickupAddress?.drivingPickupAddress,
                  })}
                >
                  {pickupAddress?.drivingPickupAddress
                    ? pickupAddress.drivingPickupAddress
                    : "请选择"}
                </span>
                <i className="arrow-icon" />
              </div>
            </div>
            {!baseInfo?.plateNumber && (
              <div className="form-item-field">
                {
                  // 选了取送车且没有车牌，需要手动输入
                }
                <span className="form-label">车牌</span>
                <div
                  className="content-side"
                  onClick={handleLinkToAddPlateNumnber}
                >
                  <span
                    className={classNames("", {
                      "has-content": !!baseInfo.addedPlateNumber,
                    })}
                  >
                    {baseInfo.addedPlateNumber
                      ? baseInfo.addedPlateNumber
                      : "请输入"}
                  </span>
                  <i className="arrow-icon" />
                </div>
              </div>
            )}
          </div>
        )}

      <div className="input-field">
        <div className="contact-name-field">
          <span className="input-label">联系人</span>
          <div
            className={classNames("input-side", {
              "show-edit":
                basicFormData.contactInfoStepData?.contactName &&
                inFocusType !== "name",
            })}
          >
            <input
              ref={nameInputRef}
              className="input-content"
              // defaultValue=""
              placeholder="请填写"
              type="text"
              value={basicFormData.contactInfoStepData?.contactName || ""}
              onChange={onContactNameChange}
              maxLength={50}
              onBlur={() => {
                setInFocusType("");
                inputFocusingRef.current = false;
              }}
              onFocus={onNameInputFocus}
            />
            <i
              className="edit-icon"
              onClick={() => {
                nameInputRef.current?.focus();
              }}
            />
          </div>
        </div>
        <div className="contact-number-field">
          <span className="input-label">联系电话</span>
          <div
            className={classNames("input-side", {
              "show-edit":
                basicFormData.contactInfoStepData?.contactPhone &&
                inFocusType !== "phone",
            })}
          >
            <input
              ref={mobileInputRef}
              className="input-content"
              // defaultValue=""
              placeholder="请填写"
              type="tel"
              value={basicFormData.contactInfoStepData?.contactPhone || ""}
              onChange={onContactPhoneChange}
              onBlur={() => {
                setInFocusType("");
                inputFocusingRef.current = false;
              }}
              onFocus={onMobileInputFocus}
            />
            <i
              className="edit-icon"
              onClick={() => {
                mobileInputRef.current?.focus();
              }}
            />
          </div>
        </div>
      </div>
      {showModal && (
        <PickupServiceModal showModal={showModal} onHide={hideModal} />
      )}
      {isPickerVisible && (
        <TimePicker
          defaultValue={
            basicFormData.contactInfoStepData?.pickupServiceTime
              ? basicFormData.contactInfoStepData?.pickupServiceTime.split(":")
              : []
          }
          showModal={isPickerVisible}
          onHide={onPickerHidden}
          onConfirm={onTimePickerConfirm}
        />
      )}
      <PickupAddress />
      <PlateInput />
    </div>
  );
}
